import { GenericCell } from '@components/design/migrated/Table';
import { ProductsCellClassType, ProductsCompareKpi } from '@models/Products';
import ProductsTableGenericCell from '@components/top-selling-products/products-table-generic-cell/ProductsTableGenericCell';
import * as tableStyles from '@components/top-selling-products/ProductsTable.module.scss';
import { FEATURE_UNAVAILABLE, ProductsCompareHeaderTitle } from '@components/products-compare-modal/Types';
import {
  getFeatureNames,
  getProcessedFeatures,
} from '@components/products-compare-modal/utils/ProductsModelCompareUtils';
import ProductsCompareModalHeaderRow from '../products-compare-modal-header-row/ProductsCompareModalHeaderRow';
import ProductsCompareModalKpiCell from '../products-compare-modal-kpi-cell/ProductsCompareModalKpiCell';

interface Props {
  productsCompareKpi: ProductsCompareKpi;
  // offsets its top position when stickied to top
  // useful when something else is stickied above it and you don't want them to overlap
  headerOffset: number;
}

const ProductsCompareModalFeatureRows: React.FC<Props> = ({ productsCompareKpi, headerOffset }) => {
  const featureNames: string[] = getFeatureNames(productsCompareKpi);
  const processedFeatures = getProcessedFeatures(productsCompareKpi);

  return (
    <>
      <ProductsCompareModalHeaderRow title={ProductsCompareHeaderTitle.FEATURES} headerOffset={headerOffset} />
      {getItemFeatures(featureNames, processedFeatures, productsCompareKpi)}
    </>
  );
};

/**
 * Populate item features row
 * @param featureNames item feature names
 * @param processedFeatures item features
 * @param productsCompareKpi compare modeal response
 */
const getItemFeatures = (
  featureNames: string[],
  processedFeatures: Map<string, Map<string | null, string | null>>,
  productsCompareKpi: ProductsCompareKpi,
) => {
  if (featureNames.length === 0) {
    return (
      <tr key={FEATURE_UNAVAILABLE} className={tableStyles.ProductsTable__TableRow__WithHover}>
        <ProductsCompareModalKpiCell headerName={FEATURE_UNAVAILABLE} colSpan={12} />
      </tr>
    );
  }
  return featureNames.map((featureName) => {
    return (
      <tr key={featureName} className={tableStyles.ProductsTable__TableRow__WithHover}>
        <ProductsCompareModalKpiCell headerName={featureName} />
        {productsCompareKpi.items.map((kpi) => {
          // defaults to filler cells for TOTAL column
          let featureValue = '';
          let key = `${featureName}_TOTAL`;

          const itemName = kpi.item.itemName;

          if (itemName !== 'TOTAL') {
            const itemId = kpi.item.itemId;
            const processedFeature = processedFeatures.get(itemId);
            key = `${itemId}_${featureName}`;

            featureValue = FEATURE_UNAVAILABLE;
            if (processedFeature && processedFeature.size > 0) {
              // Display a blank only if there is at least 1 feature for
              // a given item. Otherwise, there is currently no available
              // features
              featureValue = processedFeature.get(featureName) ?? '';
            }
          }
          return (
            <ProductsTableGenericCell key={key} cellKey={key} classType={ProductsCellClassType.FEATURE}>
              <GenericCell alignment="right" primary={featureValue} />
            </ProductsTableGenericCell>
          );
        })}
      </tr>
    );
  });
};

export default ProductsCompareModalFeatureRows;
